import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { RandomId } from "@swivl-mono/helpers";
import { PromptInterface, PromptStackItem, PromptStackItemType } from "@swivl-mono/types";
import { Button, ButtonVariant, Input, Select, SelectItem } from "@swivl-mono/ui";
import React from "react";
import { IoReorderThree } from "react-icons/io5";

import { TagInput } from "../TagInput/TagInput";

const reorder = (list: any, startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

interface StackItemProps {
  item: PromptStackItem;
  index: number;
  updateItem: (index: number, item: PromptStackItem) => void;
  promptOptions: SelectItem[];
  deleteItem(index: number): void;
}

function StackItem(props: StackItemProps) {
  const { item, index, updateItem, promptOptions, deleteItem } = props;

  const onChange = (e: any) => {
    const value = e.target.name === "numberOfMessagesToLoad" ? parseInt(e.target.value) : e.target.value;
    const newItem = { ...item, [e.target.name]: value };
    updateItem(index, newItem);
  };

  const content = React.useMemo(() => {
    if (item.type === PromptStackItemType.TEXT) {
      return (
        <TagInput
          label="Free Text"
          value={item.text}
          onChange={onChange}
          name="text"
          // variables={VariablesModel.state.allVariables}
        />
      );
    } else if (item.type === PromptStackItemType.PREVIOUS_MESSAGES) {
      return (
        <>
          <Input
            label="Load Past Messages"
            type="number"
            name="numberOfMessagesToLoad"
            value={String(item.numberOfMessagesToLoad)}
            onChange={onChange}
          />
        </>
      );
    } else if (item.type === PromptStackItemType.PROMPT) {
      return (
        <Select
          label="Prompt"
          hideClear
          options={promptOptions}
          selectedValues={item.promptSlug ? [item.promptSlug] : []}
          onChange={(vals) => {
            const newItem = { ...item, promptSlug: vals[0] ?? "" };
            updateItem(index, newItem);
          }}
        />
      );
    }
  }, [item]);

  return (
    <Draggable draggableId={item.id} index={index}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <div className="PromptStackItem">
            <div className="heading">
              <label {...provided.dragHandleProps}>
                <IoReorderThree />{" "}
              </label>
              <button
                onClick={() => {
                  deleteItem(index);
                }}
              >
                Delete
              </button>
            </div>

            {content}
          </div>
        </div>
      )}
    </Draggable>
  );
}

//   const ItemList = React.memo(function QuoteList({ quotes }) {
//     return quotes.map((quote: QuoteType, index: number) => (
//       <Quote quote={quote} index={index} key={quote.id} />
//     ));
//   });

interface Props {
  items: PromptStackItem[];
  prompts: PromptInterface[];
  stackUpdated: (items: PromptStackItem[]) => void;
}
export const PromptStack = (props: Props) => {
  const { items, stackUpdated } = props;
  // const [items, setItems] = useState(props.items);
  // const prompts = AIModel.useState(s => s.prompts)

  const addPrompt = (prompt: PromptStackItem) => {
    stackUpdated([...items, prompt]);
  };
  const deleteItem = (index: number) => {
    const newItems = [...items];
    newItems.splice(index, 1);
    stackUpdated(newItems);
  };

  const updateItem = (index: number, item: PromptStackItem) => {
    const newItems = [...items];
    newItems[index] = item;
    stackUpdated(newItems);
  };

  function onDragEnd(result: any) {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    stackUpdated(reorder(items, result.source.index, result.destination.index) as any);
  }

  const promptOptions: SelectItem[] = props.prompts.map((prompt) => ({
    label: prompt.name,
    value: prompt.slug
  }));

  return (
    <div className="PromptStack">
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="list">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {items.map((item, index) => (
                <StackItem deleteItem={deleteItem} key={item.id} item={item} index={index} updateItem={updateItem} promptOptions={promptOptions} />
              ))}

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <div className="buttons">
        <Button
          onClick={() => {
            addPrompt({
              id: RandomId(8),
              type: PromptStackItemType.TEXT,
              text: ""
            });
          }}
          variant={ButtonVariant.DASHED}
        >
          + Free Text
        </Button>
        <Button
          onClick={() => {
            addPrompt({
              id: RandomId(8),
              type: PromptStackItemType.PROMPT,
              promptSlug: ""
            });
          }}
          variant={ButtonVariant.DASHED}
        >
          + Prompt
        </Button>
      </div>
    </div>
  );
};
